import View, { ViewOpts } from '@play-co/timestep-core/lib/ui/View';
import {
  BuddiesRankingEntry,
  BuddiesRankingEntryParams,
} from './BuddiesRankingEntry';
import { animate } from '@play-co/timestep-core/ui';
import sounds from 'src/lib/sounds';

export class BuddiesRanking extends View {
  private entries: BuddiesRankingEntry[] = [];

  constructor(opts: ViewOpts) {
    super(opts);
  }

  public setup(entries: BuddiesRankingEntryParams[]) {
    const spacing = 100;
    // Create an entry view for each sorted entry
    entries.forEach((entryData, index) => {
      const entryView = new BuddiesRankingEntry({
        superview: this,
        width: 500,
        centerOnOrigin: true,
        y: index * spacing, // Assuming each entry has a height of 100px
      });
      entryView.setup(entryData);
      this.entries.push(entryView);
    });
  }

  public async showAnimated() {
    this.show();
    const promises: Promise<void>[] = [];

    this.entries.forEach((entry, i) => {
      entry.updateOpts({ offsetY: 200, opacity: 0 });
      const promise = animate(entry)
        .wait(i * 200)
        .then(() => {
          sounds.sfx.play('puzzle-doghouse-1-2');
        })
        .then({ offsetY: 0, opacity: 1 }, 300, animate.easeOutQuad)
        .toPromise();
      promises.push(promise);
    });

    await Promise.all(promises);
  }
}
